// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_e9-6";
export var emphasizeQuantity = "_e9-3";
export var flatBottomCorners = "_e9-5";
export var productImage = "_e9-0";
export var quantityContainer = "_e9-2";
export var tooltip = "_e9-1";
export var wrapAndEllipsesOverflow = "_e9-4";